module.exports = __webpack_public_path__ + "static/media/socks-logo.f8374d30.png";